import type { SplitCopy } from "../content/types.js";
import { photoById, shortName } from "./photos.js";

const IDS = ["c03", "c09", "c12", "c16", "c17", "c27"];

export function Angles({ copy }: { readonly copy: SplitCopy }) {
  return (
    <section class="section angles" data-theme="dark">
      <div class="wrap angles-grid">
        <div class="angles-text">
          <p class="micro">{copy.label}</p>
          <h2 class="section-title serif">{copy.title}</h2>
          <p class="split-body">{copy.body}</p>
        </div>
        <div class="angles-photos">
          {IDS.map(photoById).map((photo, index) => (
            <figure key={photo.id} class="angles-tile" style={{ "--i": index }}>
              <img src={photo.small} alt="" width={560} height={700} loading="lazy" />
              <figcaption>{shortName(photo.author)}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
